import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

function notificacoesPushLoading(data) {
    return {
        type: 'NOTIFICACOES_PUSH_LOADING',
        payload: data
    }
}

function notificacoesPushProcessing(data) {
    return {
        type: 'NOTIFICACOES_PUSH_PROCESSING',
        payload: data
    }
}

function carregarNotificacoesPush(data) {
    return {
        type: 'NOTIFICACOES_PUSH_FETCHED',
        payload: data
    }
}

function carregarNotificacaoPush(data) {
    return {
        type: 'NOTIFICACAO_PUSH_FETCHED',
        payload: data
    }
}

export function carregarUploadedFiles(data) {
    return {
        type: 'UPLOADED_FILES',
        payload: data
    }
}

function atualizarUploadedFiles(data) {
    return {
        type: 'UPDATE_UPLOADED_FILES',
        payload: data
    }
}

export function getNotificacoesPush() {
    return dispatch => {
        dispatch(notificacoesPushLoading(true));
        axios.get(`${URL}/notificacoes/listar`)
            .then(resp => {
                dispatch(carregarNotificacoesPush(resp.data));
                dispatch(notificacoesPushLoading(false));
            })
            .catch(e => {
                dispatch(notificacoesPushLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function getNotificacaoPush(id) {
    return dispatch => {
        dispatch(notificacoesPushLoading(true));
        axios.get(`${URL}/notificacoes/admin/${id}`)
            .then(resp => {
                dispatch(carregarNotificacaoPush(resp.data));
                dispatch(notificacoesPushLoading(false));
            })
            .catch(e => {
                dispatch(notificacoesPushLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function addNotificacaoPush(values) {
    return dispatch => {
        dispatch(notificacoesPushProcessing(true));
        const formData = new FormData();

        if (values.file) {
            formData.append('file', values.file);
        }

        formData.append('conteudo', JSON.stringify(
            {
                id: values.id,
                titulo: values.titulo,
                conteudo: values.conteudo,
                conteudoExpandido: values.conteudoExpandido,
                imagemBanner: values.imagemBanner,
                targetType: values.targetType,
                targetId: values.targetId,
                actionType: values.actionType,
                actionPayload: values.actionPayload,
            }
        ));

        axios.post(`${URL}/notificacoes/enviar`, formData, {
            // O Axios define o Content-Type: multipart/form-data automaticamente com FormData
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                // O idTemp aqui é único para cada arquivo disparado no loop
                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, progress }));
            }
        })
            .then(resp => {
                dispatch(atualizarUploadedFiles({
                    idTemp: values.idTemp,
                    url: resp.data.url,
                    uploaded: true,
                }));
            })
            .then(_ => {
                dispatch(notificacoesPushProcessing(false));
                dispatch(getNotificacoesPush());
                toastr.success('Sucesso', 'Notificação push enviada com sucesso.');
                return true;
            })
            .catch(e => {
                dispatch(notificacoesPushProcessing(false));

                try {
                    const data = e.response.data;

                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;

                        if (status === 400 && Array.isArray(errors)) {
                            errors.forEach(erro => {
                                toastr.error(msg, `Campo: ${erro.fieldName}. ${erro.message}`);
                            });
                        } else {
                            toastr.error(msg || 'Erro', `Erro: ${status || 'desconhecido'}`);
                        }

                        return false;
                    }
                } catch (error) {
                    toastr.error('Erro inesperado', 'Não foi possível enviar a notificação push. Tente novamente em alguns instantes.');
                }

                dispatch(atualizarUploadedFiles({ idTemp: values.idTemp, error: true }));

                return false;
            });
    }
}